import { ReactNode } from 'react'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Link } from 'react-router-dom'
import { IconButton, Typography } from '@mui/material'

import useStyles from './styles'
import { useCopy } from 'src/hooks'

interface IProps {
  title: ReactNode
  link: string | null
  withCopy?: boolean
}

export const UrlLink = ({ title, link, withCopy }: IProps) => {
  const classes = useStyles()
  const copy = useCopy(link)

  return (
    <div>
      <Typography className={classes.title}>{title}</Typography>
      <div>
        <Typography
          component={!!link ? Link : 'span'}
          to={link || undefined}
          target={link ? '_blank' : undefined}
          className={classes.text}
        >
          {link || '-'}
        </Typography>
        {withCopy && (
          <IconButton size="small" onClick={copy}>
            <ContentCopyIcon fontSize={'inherit'} />
          </IconButton>
        )}
      </div>
    </div>
  )
}
